const InputView = require('./input_view')


const InputTextView = InputView.extend({

    attribute_keys: [
        'type',
        'id',
        'name',
        'value',
        'size',
        'placeholder',
        'maxlength',
        'spellcheck',
        'disabled',
        'autocapitalize',
        'autocomplete',
        'autocorrect',
    ],

    triggers: {
        'change': 'input:change',
        'keydown': {
            event: 'input:change',
            preventDefault: false,
            stopPropagation: false,
        },
        'keyup': {
            event: 'input:change',
            preventDefault: false,
            stopPropagation: false,
        },
    },

})

module.exports = InputTextView
